import ErrorMessage from '../components/ErrorMessage';
import { StoreState } from '../types/index';
import { connect } from 'react-redux';

export function mapStateToProps({ results }: StoreState.All) {
  if (results) {
    return { error: results.error };
  } else {
    return { error: null };
  }
}

export default connect(mapStateToProps)(ErrorMessage);